const DEFAULT_MARGIN = 10;
export function calculateAndScrollIntoView(containerRef, headerEl, contentEl) {
  const scroller = containerRef == null ? void 0 : containerRef.current;
  if (!scroller) {
    return;
  }
  const rectContainer = scroller.getBoundingClientRect();
  const rectHeader = headerEl.getBoundingClientRect();
  const rectContent = (contentEl == null ? void 0 : contentEl.getBoundingClientRect()) ?? rectHeader;
  const scrollTop = scroller.scrollTop;
  const containerTop = rectContainer.top;
  const containerBottom = rectContainer.bottom;
  const headerTopY = rectHeader.top - containerTop + scrollTop - DEFAULT_MARGIN;
  const contentBottomY = rectContent.bottom - containerTop + scrollTop + DEFAULT_MARGIN;
  const targetBottomTop = contentBottomY - scroller.clientHeight;
  const isTopVisible = rectHeader.top >= containerTop;
  const isBottomVisible = rectContent.bottom <= containerBottom;
  if (!isTopVisible) {
    scroller.scrollTo({
      behavior: 'smooth',
      top: headerTopY
    });
    return;
  }
  if (!isBottomVisible) {
    const targetTop = Math.min(headerTopY, targetBottomTop);
    scroller.scrollTo({
      behavior: 'smooth',
      top: targetTop
    });
  }
}
//# sourceMappingURL=scroll-calculations.js.map